import * as tslib_1 from "tslib";
/* I11 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
import { useFlag } from '../../redux/flags/hooks/useFlag';
var Favourite = function (props) {
    var isUplifted = useFlag('actionbar_phase_1');
    return (React.createElement(IconWrap, tslib_1.__assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", null, isUplifted ? (React.createElement("polygon", { points: "6.887 22 5.161 20.682 6.137 14.725 2 10.436 2.658 8.299 8.379 7.458 10.932 2 13.054 2 15.621 7.458 21.342 8.329 22 10.436 17.863 14.681 18.839 20.675 17.113 21.993 12 19.171" })) : (React.createElement("path", { d: "M12 17.17l-5.562 2.712L7.5 14.136 3 10.066l6.219-.838L12 4l2.781 5.228 6.219.839-4.5 4.07 1.062 5.745z" }))))));
};
Favourite.displayName = 'Favourite';
export default Favourite;
//# sourceMappingURL=Favourite.js.map